// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4989":"48fc2f32053ae2d831b6","9249":"ec7629189d911a2afebe"}[chunkId] + ".chunk.js";
};